import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function RedditIcon({
	width,
	height,
	active = false,
	'aria-label': ariaLabel = 'Reddit',
	style,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30,30,30,.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>Reddit</title>
			<path
				d="M30.5348 0H9.46517C4.2377 0 0 4.2377 0 9.46517V30.5348C0 35.7623 4.2377 40 9.46517 40H30.5348C35.7623 40 40 35.7623 40 30.5348V9.46517C40 4.2377 35.7623 0 30.5348 0Z"
				fill={bg}
			/>
			<g transform="translate(4.5 4.5) scale(0.17)">
				<path
					d="M151.4 90.6c-.3-7.3-6.4-13.1-13.8-12.8-3.3.1-6.4 1.4-8.7 3.7-10.4-7.1-22.6-10.9-35.1-11.2l5.9-28.4 19.5 4.1c.5 5 5 8.6 10 8.1s8.6-5 8.1-10-5-8.6-10-8.1c-2.9.3-5.5 2-6.9 4.5L98.1 36c-1.5-.3-3 .6-3.4 2.2L88 69.7c-12.7.2-25 4.1-35.5 11.2-5.3-5-13.8-4.8-18.8.6-5 5.3-4.8 13.8.6 18.8q1.5 1.5 3.6 2.4c-.1 1.3-.1 2.7 0 4 0 20.4 23.8 37 53.1 37s53.1-16.6 53.1-37c.1-1.3.1-2.7 0-4 4.5-2.3 7.4-7 7.3-12.1m-91.1 9.1c0-5 4.1-9.1 9.1-9.1s9.1 4.1 9.1 9.1-4.1 9.1-9.1 9.1c-5.1 0-9.1-4-9.1-9.1m52.9 25.4v-.4c-6.5 4.9-14.4 7.4-22.5 7-8.1.3-16-2.2-22.5-7-.9-1-.7-2.6.3-3.5.9-.7 2.2-.7 3.1 0 5.5 4 12.2 6 19 5.7 6.8.4 13.5-1.6 19-5.5 1-1 2.6-1 3.6 0 1 1.1 1 2.8 0 3.7m-1.3-15.6h-.5l.1-.3c-5 0-9.1-4.1-9.1-9.1s4.1-9.1 9.1-9.1 9.1 4.1 9.1 9.1c.3 5-3.6 9.2-8.7 9.4"
					fill={g}
				/>
			</g>
		</svg>
	);
}
